// import React, { useState } from 'react';
// import './Signup.css';
// import { useNavigate } from 'react-router-dom';

// function UserSignupForm() {
//   const [name, setName] = useState('');
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [skills, setSkills] = useState([]);
//   const [resume, setResume] = useState(null);
//   const [errorMessage, setErrorMessage] = useState('');

//   const navigate = useNavigate();

//   const handleFileChange = (e) => {
//     setResume(e.target.files[0]);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       // Prepare FormData for sending both file and text data
//       const formData = new FormData();
//       formData.append('name', name);
//       formData.append('email', email);
//       formData.append('password', password);
//       formData.append('skills', skills.split(',').map((skill) => skill.trim()).join(','));
//       if (resume) formData.append('resume', resume);

//       const response = await fetch('/api/signup-apply', {
//         method: 'POST',
//         body: formData,
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.error || 'Signup failed.');
//       }

//       console.log('Signup successful:', data);
//       localStorage.setItem('user_email', email);
//       navigate(`/login_user`);
//     } catch (error) {
//       console.error('Error in signup request:', error);
//       setErrorMessage(error.message || 'Signup failed.');
//     }
//   };


//   return (
//     <div className="joinus-signup">
//       <div className="section-container">
//         <img
//           loading="lazy"
//           src="./sgn.png" alt="Join us illustration"
//           className="login-image"
//         />
//         <div className="joinus-content">
//           <div className="content1">
//             <h1 className="joinus-title">Join us today 👋</h1>
//             <p className="joinus-subtitle">
//               Together, We Create Opportunities for Growth, Collaboration, and
//               Innovation – Join Us to Be a Part of Something Bigger.
//             </p>
//           </div>
//           <div className="content2">
//             <form onSubmit={handleSubmit}>
//               <div className="joinus-input-group">
//                 <label htmlFor="name" className="joinus-input-label">Name</label>
//                 <input
//                   type="text"
//                   id="company"
//                   className="joinus-input-field"
//                   placeholder="Your name"
//                   value={name}
//                   onChange={(e) => setName(e.target.value)}
//                   required
//                 />
//               </div>
//               <div className="joinus-input-group">
//                 <label htmlFor="email" className="joinus-input-label">Email Address</label>
//                 <input
//                   type="email"
//                   id="email"
//                   className="joinus-input-field"
//                   placeholder="i.e. example@innova.com"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   required
//                 />
//               </div>

//               <div className="joinus-input-group">
//                 <label htmlFor="password" className="joinus-input-label">Password</label>
//                 <input
//                   type="password"
//                   id="passwordd"
//                   className="joinus-input-field"
//                   placeholder="**********"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   required
//                 />
//               </div>

//               <div className="joinus-input-group">
//                 <label htmlFor="skills" className="joinus-input-label">Skills</label>
//                 <input
//                   type="text"
//                   id="skills"
//                   className="joinus-input-field"
//                   placeholder="e.g., JavaScript, Python, React"
//                   value={skills}
//                   onChange={(e) => setSkills(e.target.value)}
//                   required
//                 />
//               </div>

//               <div className="joinus-input-group">
//                 <label htmlFor="resume" className="joinus-input-label">Resume</label>
//                 <input
//                   type="file"
//                   id="resume"
//                   className="joinus-input-field"
//                   accept=".pdf,.doc,.docx"
//                   onChange={handleFileChange}
//                   required
//                 />
//               </div>

//               <div className="joinus-remember-me">
//                 <input
//                   type="checkbox"
//                   id="remember"
//                   className="joinus-checkbox"
//                 />
//                 <label htmlFor="remember">Remember me</label>
//               </div>

//               <button className="joinus-create-account-btn" type="submit">
//                 Create Account
//               </button>
//               {errorMessage && <p className="error-message">{errorMessage}</p>}

//               <p className="joinus-login-link">
//                 Already have an account? <a href="/login_user">Log in</a>
//               </p>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default UserSignupForm;


// ✅ Updated Signup.jsx with OTP Modal Integration
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import OtpModal from '../../OtpBox/OtpModal';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Text, Heading } from '@/components/ui/typography';
import { User, Mail, Lock, Briefcase, FileText, Phone } from 'lucide-react';
import { cn } from '@/lib/utils';
import { getColor } from '@/config/theme';
import {
  normalizeEmail,
  isValidEmail,
  validatePassword,
  validateResumeFile,
} from '@/utils/formValidation';

function UserSignupForm() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [skills, setSkills] = useState([]);
  const [phone, setPhone] = useState('');
  const [whatsappConsent, setWhatsappConsent] = useState(false);
  const [resume, setResume] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [otpVisible, setOtpVisible] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleFileChange = (e) => {
    const nextFile = e.target.files[0];
    const resumeError = validateResumeFile(nextFile);
    if (resumeError) {
      setErrorMessage(resumeError);
      e.target.value = '';
      setResume(null);
      return;
    }

    setErrorMessage('');
    setResume(nextFile);
  };

  const validateForm = () => {
    const normalizedEmail = normalizeEmail(email);

    if (!name.trim()) {
      return 'Name is required.';
    }
    if (name.trim().length < 2) {
      return 'Name must be at least 2 characters.';
    }
    if (!normalizedEmail) {
      return 'Email is required.';
    }
    if (!isValidEmail(normalizedEmail)) {
      return 'Please enter a valid email address.';
    }

    const passwordError = validatePassword(password);
    if (passwordError) {
      return passwordError;
    }

    if (!skills.trim()) {
      return 'Skills are required.';
    }

    const resumeError = validateResumeFile(resume);
    if (resumeError) {
      return resumeError;
    }

    return '';
  };

  const handleSignupClick = async (e) => {
    e.preventDefault();
    const validationError = validateForm();
    if (validationError) {
      setErrorMessage(validationError);
      return;
    }

    setErrorMessage('');
    setLoading(true);
    const normalizedEmail = normalizeEmail(email);
    const res = await fetch('/api/send_otp', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: normalizedEmail, phone: phone.trim() })
    });
    if (res.ok) {
      setEmail(normalizedEmail);
      setOtpVisible(true);
      setLoading(false);
    } else {
      const data = await res.json();
      setErrorMessage(data.error || 'OTP sending failed');
      setLoading(false);
    }
  };

  const handleOtpVerify = async (enteredOtp) => {
    const normalizedEmail = normalizeEmail(email);
    const res = await fetch('/api/verify_otp', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ otp: enteredOtp, email: normalizedEmail })
    });
    const data = await res.json();
    if (res.ok && data.verified) {
      setOtpVisible(false);
      setOtpVerified(true);
      await handleSubmit();
    } else {
      setErrorMessage(data.error || 'Invalid OTP');
    }
  };

  const handleSubmit = async () => {
    try {
      const validationError = validateForm();
      if (validationError) {
        setErrorMessage(validationError);
        return;
      }

      setLoading(true);
      const formData = new FormData();
      formData.append('name', name.trim());
      formData.append('email', normalizeEmail(email));
      formData.append('password', password);
      formData.append('skills', skills.split(',').map((skill) => skill.trim()).join(','));
      formData.append('phone', phone.trim());
      formData.append('whatsapp_consent', whatsappConsent ? '1' : '0');
      if (resume) formData.append('resume', resume);

      const response = await fetch('/api/signup-apply', {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Signup failed.');
      }

      console.log('Signup successful:', data);
      localStorage.setItem('user_email', email);
      navigate(`/login_user`);
    } catch (error) {
      console.error('Error in signup request:', error);
      setErrorMessage(error.message || 'Signup failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full bg-background text-foreground flex flex-col justify-center items-center relative overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.02] pointer-events-none">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, hsl(var(--foreground)) 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>

      {/* Logo Section - Top Left */}
      <div className="absolute top-6 left-6 md:top-8 md:left-8 z-10">
        <Link 
          to="/"
          className="transition-opacity hover:opacity-80"
        >
          <img
            src="/Logo.png"
            alt="Logo"
            className="h-8 md:h-10 w-auto object-contain drop-shadow-sm"
          />
        </Link>
      </div>
      
      <div className="flex justify-center items-center gap-12 max-w-7xl w-full flex-wrap px-6 py-12 md:flex-nowrap relative z-10">
        <Card className={cn(
          "flex flex-col w-full max-w-[480px] p-8 md:p-10",
          "bg-white border border-border/50",
          "shadow-xl shadow-primary/5",
          "transition-all duration-300",
          "hover:shadow-2xl hover:shadow-primary/10"
        )}>
          <CardContent className="w-full p-0 space-y-6">
            {/* Header */}
            <div className="space-y-3 mb-2">
              <Heading level="h1" className="text-4xl font-bold text-foreground tracking-tight">
                Join us today 👋
              </Heading>
              <Text size="base" variant="muted" className="text-muted-foreground leading-relaxed">
                Together, we create opportunities for growth, collaboration, and innovation – join us to be a part of something bigger.
              </Text>
            </div>

            {/* Form */}
            <form className="flex flex-col gap-5" onSubmit={handleSignupClick}>
              <div className="space-y-4">
                <div className="relative group/name">
                  <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none z-10 transition-colors group-focus-within/name:text-primary" />
                  <Input
                    type="text"
                    id="name"
                    placeholder="Your name"
                    aria-label="Name"
                    className="w-full pl-10 pr-3 h-10 py-2 transition-all"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>

                <div className="relative group/email">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none z-10 transition-colors group-focus-within/email:text-primary" />
                  <Input
                    type="email"
                    id="email"
                    placeholder="Enter your email"
                    aria-label="Email Address"
                    className="w-full pl-10 pr-3 h-10 py-2 transition-all"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="relative group/password">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none z-10 transition-colors group-focus-within/password:text-primary" />
                  <Input
                    type="password"
                    id="passwordd"
                    placeholder="Enter your password"
                    aria-label="Password"
                    className="w-full pl-10 pr-3 h-10 py-2 transition-all"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>

                <div className="relative group/skills">
                  <Briefcase className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none z-10 transition-colors group-focus-within/skills:text-primary" />
                  <Input
                    type="text"
                    id="skills"
                    placeholder="e.g., JavaScript, Python, React"
                    aria-label="Skills"
                    className="w-full pl-10 pr-3 h-10 py-2 transition-all"
                    value={skills}
                    onChange={(e) => setSkills(e.target.value)}
                    required
                  />
                </div>

                <div className="relative group/phone">
                  <Phone className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none z-10 transition-colors group-focus-within/phone:text-primary" />
                  <Input
                    type="tel"
                    id="phone"
                    placeholder="+91 98765 43210"
                    aria-label="Phone Number"
                    className="w-full pl-10 pr-3 h-10 py-2 transition-all"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                  />
                </div>

                <div>
                  <div className="relative group/resume">
                    <FileText className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none z-10" />
                    <Input
                      type="file"
                      id="resume"
                      accept=".pdf,.doc,.docx"
                      onChange={handleFileChange}
                      className="w-full pl-10 pr-3 h-10 py-2 transition-all cursor-pointer"
                      aria-label="Resume (optional)"
                    />
                  </div>
                  <p className="mt-1.5 text-xs text-muted-foreground">
                    Resume (optional) — PDF, DOC, or DOCX.
                  </p>
                </div>
              </div>

              <div className="flex items-center space-x-2">
                <Checkbox id="remember" />
                <Label
                  htmlFor="remember"
                  className="text-sm font-normal cursor-pointer text-muted-foreground"
                >
                  Remember me
                </Label>
              </div>

              <div className="flex items-center space-x-2">
                <Checkbox id="whatsappConsent" checked={whatsappConsent} onCheckedChange={setWhatsappConsent} />
                <Label htmlFor="whatsappConsent" className="text-sm font-normal cursor-pointer text-muted-foreground">
                  I agree to receive updates from SearchJob.ai on WhatsApp
                </Label>
              </div>

              {errorMessage && (
                <div className="rounded-md bg-destructive/10 border border-destructive/20 p-3">
                  <Text size="sm" variant="destructive" className="text-destructive">
                    {errorMessage}
                  </Text>
                </div>
              )}

              <Button 
                type="submit" 
                variant="default"
                size="default"
                disabled={loading}
                className="w-full h-11 font-semibold shadow-sm hover:shadow-md transition-all duration-200"
                style={{
                  backgroundColor: getColor('primary'),
                  color: getColor('primaryForeground'),
                  borderColor: getColor('primary')
                }}
              >
                {loading ? 'Creating Account...' : 'Create Account'}
              </Button>
            </form>

            {/* Footer */}
            <div className="pt-4 text-center border-t border-border">
              <Text size="sm" variant="muted" className="text-muted-foreground">
                Already have an account?{' '}
                <Link 
                  to="/login_user" 
                  className={cn(
                    "text-primary hover:text-primary/90 font-bold",
                    "transition-colors underline-offset-4 hover:underline",
                    "text-base"
                  )}
                >
                  Log in
                </Link>
              </Text>
            </div>
          </CardContent>
        </Card>
        
        <div className="hidden lg:block flex-shrink-0">
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-br from-primary/10 via-primary/5 to-transparent rounded-2xl blur-2xl" />
            <img 
              className="relative w-full max-w-[520px] aspect-[0.72] object-cover rounded-2xl shadow-2xl"
              loading="lazy"
              src="./abcd.png"
              alt="Sign up illustration"
            />
          </div>
        </div>
      </div>
      
      <OtpModal
        visible={otpVisible}
        onVerify={handleOtpVerify}
        onCancel={() => setOtpVisible(false)}
        onResend={handleSignupClick}
        email={email}
      />
    </div>
  );
}

export default UserSignupForm;
